import { render } from "./AddVersionModal.vue?vue&type=template&id=55a7912c"
import script from "./AddVersionModal.vue?vue&type=script&lang=js"
export * from "./AddVersionModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__